import {RouteLang} from "./enum/route-lang.enum";

export const menuMainItems = [
    {
        identifier: 'home',
        path: {
            [RouteLang.EN]: '/',
            [RouteLang.FR]: '/',
            [RouteLang.NL]: '/',
        },
    },
    {
        identifier: 'team',
        path: {
            [RouteLang.EN]: '/team',
            [RouteLang.FR]: '/equipe',
            [RouteLang.NL]: '/team',
        }
    },
    {
        identifier: 'projects',
        path: {
            [RouteLang.EN]: '/projects',
            [RouteLang.FR]: '/projets',
            [RouteLang.NL]: '/projecten',
        }
    },
    {
        identifier: 'pro',
        path: {
            [RouteLang.EN]: '/installers-design-offices',
            [RouteLang.FR]: '/installateurs-bureau-d-etudes',
            [RouteLang.NL]: '/installateurs-ontwerpbureaus',
        }
    },
    {
        identifier: 'contact',
        path: {
            [RouteLang.EN]: '/contact-and-quote',
            [RouteLang.FR]: '/contact-et-devis',
            [RouteLang.NL]: '/contact-en-offerte',
        }
    },
    {
        identifier: 'privacy-policy',
        secondary: true,
        path: {
            [RouteLang.EN]: '/privacy-policy',
            [RouteLang.FR]: '/politique-de-confidentialite',
            [RouteLang.NL]: '/privacy-beleid',
        }
    }
];